function videosGridClass(count) {
  if (count === 3) return "md:grid-cols-3";
  if (count === 2) return "md:grid-cols-2";
  return "grid-cols-1";
}

export function VenueVideosSection({ venueName, videoIds }) {
  return (
    <section
      data-track-section="venue-video"
      data-testid="venue-video-section"
      className="bg-[#21201F] text-white px-6 md:px-12 lg:px-16 py-24 md:py-32 text-center"
    >
      <div className={videoIds.length > 1 ? "max-w-6xl mx-auto" : "max-w-5xl mx-auto"}>
        <div className="text-xs tracking-overline uppercase text-[#A9927D] mb-4 font-medium">
          Filmed At Your Venue
        </div>
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-tight mb-12">
          {videoIds.length > 1 ? "Here are some other couples" : "Here is a couple"} we captured at{" "}
          <span className="italic font-light">{venueName}</span>...
        </h2>
        <div className={`grid gap-6 ${videosGridClass(videoIds.length)}`}>
          {videoIds.map((v) => (
            <div
              key={v.key}
              className="aspect-video w-full overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.4)]"
            >
              {v.type === "yt" ? (
                <iframe
                  src={`https://www.youtube.com/embed/${v.id}?rel=0&enablejsapi=1&origin=${encodeURIComponent(window.location.origin)}`}
                  title={`Wedding film at ${venueName}`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  data-testid="venue-video-iframe"
                  data-track-video={v.id}
                  className="w-full h-full"
                />
              ) : (
                <iframe
                  src={v.url}
                  title={`Wedding film at ${venueName}`}
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
                  data-testid="venue-video-vidflow-iframe"
                  className="w-full h-full"
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
